module.exports = __webpack_public_path__ + "img/bg.ffe5b3cb.png";